'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var POSITION = exports.POSITION = {
  STATIC: 0,
  RELATIVE: 1,
  ABSOLUTE: 2,
  FIXED: 3,
  STICKY: 4
};

var parsePosition = exports.parsePosition = function parsePosition(position) {
  switch (position) {
    case 'relative':
      return POSITION.RELATIVE;

    case 'absolute':
      return POSITION.ABSOLUTE;

    case 'fixed':
      return POSITION.FIXED;

    case 'sticky':
      return POSITION.STICKY;
  }

  return POSITION.STATIC;
};